import React, { useRef, useState } from "react";
import Editor from "../../../common/Editor/Editor";
import { onImageHandler } from "../../../components/UploadImageOnBucket";
import { TbEditCircle } from "react-icons/tb";
import { useDispatch } from "react-redux";
import { CustomizeProductSlice, EditCustomizeProductListSlice } from "../../../redux/features/ProductCatalogueSlice";
import { toast } from "react-toastify";

const EditCustomizeProduct = ({data,showModal,setShowModal}) => { 
  const dispatch = useDispatch();
  const CustomizeRef = useRef();
  console.log(data);
  const [productDetails, setProductDetails] = useState({
    productName: data?.name,
    productPrice: data?.price,
    productImage: data?.customimage,
    productDescription: data?.description,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductDetails({
      ...productDetails,
      [name]: value,
    });
  };

  const handleFileChange = async(e) => {
    try {
      const data = await onImageHandler(e);
      setProductDetails({
        ...productDetails,
        productImage: data[1].location,
      });
    } catch (error) {
      toast.error('Something went worng with AWS bucket')
    }
  };

  const handleSubmit = () => {
    const dataForSend = {
      "name":productDetails?.productName,
      "price":productDetails?.productPrice,
      "customimage":productDetails?.productImage,
      "description":productDetails?.productDescription
  }

  if(Object.entries(dataForSend).some(([key,value])=>{
    if([undefined,null,''].includes(value) || String(value)?.trim()?.length===0){
      toast.error(`Please fill this field ${key}`)
      return true;
    }
  })){
    return;
  }

  dispatch(EditCustomizeProductListSlice({id:data?._id,data:dataForSend})).then((res)=>{
    CustomizeRef?.current?.click();
  })
  };

  return (
    <div className="ModalBox">
      <div
        id="EditProductCustomize"
        className={`modal fade MediumModal`}
        data-backdrop="static"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Small-Wrapper">
                <div className="TitleBox">
                  <h2>Product Customization Details</h2>
                </div>
                <div className="row">
                  <div>
                    <div className="ItineraryArea" style={{ padding: "20px 20px 0 0", border: "none" }}>
                      <div className="row">
                        <div className="" style={{ padding: "0 30px" }}>
                          {/* Close Button */}
                          <button
                            className="CloseModal"
                            data-dismiss="modal"
                            style={{
                              position: "absolute",
                              top: "-15px",
                              right: "-10px",
                              height: 20,
                              width: 20,
                              borderRadius: "100%",
                              backgroundColor: "lightgray",
                              border: "none",
                              cursor: "pointer",
                            }}
                            ref={CustomizeRef}
                            onClick={()=>setShowModal((prev)=>({...prev,edit:!prev['edit']}))}
                          >
                            ×
                          </button>

                          {/* Product Details Form */}
                          <div
                            style={{
                              minWidth: "100%",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                              marginBottom: 20,
                              border: "1px solid lightgray",
                              padding: 10,
                              borderRadius: 10,
                            }}
                          >
                            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                              <div>
                                <p className="label">Product Name</p>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="productName"
                                  value={productDetails.productName}
                                  onChange={handleChange}
                                />
                              </div>
                              <div>
                                <p className="label">Product Price</p>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="productPrice"
                                  value={productDetails.productPrice}
                                  onChange={handleChange}
                                />
                              </div>
                              {/* <div>
                                <p className="label">Product Image</p>
                                <div
                                  style={{
                                    position: "relative",
                                    width: 100,
                                    height: 60,
                                    border: "2px dotted grey",
                                    backgroundColor: "rgba(110, 96, 96, 0.11)",
                                  }}
                                >
                                  <input
                                    type="file"
                                    className="form-control"
                                    accept=".png,.jpg,.jpeg"
                                    name="productImage"
                                    onChange={handleFileChange}
                                    style={{
                                      width: "100%",
                                      cursor: "pointer",
                                      height: "100%",
                                      opacity: 0,
                                      position: "absolute",
                                    }}
                                  />
                                </div>
                              </div> */}
                                <div className="form-group">
                  <label>Upload Images/Video </label>
                  <div className="UploadBox">
                    <div className="Upload" style={{ padding: "0" }}>
                      {false ? (
                        // <Skeleton width={"100%"} height={"130px"} />
                        'hi'
                      ) : productDetails?.productImage?.length > 0 ? (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          <img
                            src={productDetails?.productImage}
                            style={{ height: "100%", width: "100%" }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="file"
                              onChange={handleFileChange}
                              style={{
                                height: "100%",
                                width: "100%",
                                opacity: "0",
                              }}
                            />
                            <TbEditCircle
                              style={{
                                fontSize: "20px",
                                backgroundColor: "gray",
                                color: "wheat",
                                cursor: "pointer",
                                borderRadius: "10px",
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <>
                          <i className="fa fa-upload" /> <span>Upload </span>
                          <input type="file" onChange={handleFileChange}/>
                        </>
                      )} 
                    </div>
                  </div>
                </div>
                            </div>
                            <Editor  type={"Productcustomize"} setContentState={setProductDetails} content={productDetails.productDescription}  />
                          </div>

                          <button
                            type="button"
                            onClick={handleSubmit}
                            style={{
                              width: "100%",
                              border: "none",
                              margin: "10px 0px",
                              color: "white",
                              padding: 10,
                              borderRadius: 5,
                              backgroundImage: "linear-gradient(45deg, rgb(175, 31, 243), rgb(191, 78, 244))",
                            }}
                          >
                            Add Customize Product
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCustomizeProduct;
